// Validazione targhe italiane — copre i formati ufficiali (Reg. CdS, App. XII art. 257
// e successive evoluzioni). La stringa viene normalizzata (maiuscolo, senza spazi/trattini)
// prima del confronto. L'obiettivo è accettare tutti i formati validi e rifiutare solo le
// stringhe chiaramente errate. In caso di stringa vuota si considera valida (non bloccante).

export const normTarga = (t) => String(t || "").toUpperCase().replace(/[^A-Z0-9]/g, "");

// Lettere ammesse dal Codice della Strada (escluse alcune per evitare ambiguità),
// ma restiamo permissivi con [A-Z] dove il formato lo consente.
const TARGA_PATTERNS = [
  // Autoveicoli / Motoveicoli standard (dal 1994): AB123CD
  /^[A-Z]{2}\d{3}[A-Z]{2}$/,
  // Precedenti al 1994 (sigla provincia + progressivo): PA12345, RM123456
  /^[A-Z]{2}\d{5,6}$/,
  // Motocicli / ciclomotori (2 lettere + 5 cifre): AB12345
  /^[A-Z]{2}\d{5}$/,
  // Vecchio formato moto (2 lettere + 2 cifre + 2 lettere): AB12CD
  /^[A-Z]{2}\d{2}[A-Z]{2}$/,
  // Vecchio formato auto (3 lettere + 3 cifre): ABC123
  /^[A-Z]{3}\d{3}$/,
  // Ciclomotori targhino ante-2004 (lettere e numeri variabili)
  /^[A-Z]\d{4}$/,             // X1234
  /^\d{4}[A-Z]$/,             // 1234X
  /^[A-Z]{2}\d{4}$/,          // AB1234
  /^[A-Z]\d{2}[A-Z]{2}$/,     // A12BC
  /^\d{2}[A-Z]{3}$/,          // 12ABC
  // Rimorchi / carrelli appendice (dal 2012): XA123AB
  /^X[A-Z]\d{3}[A-Z]{2}$/,
  // Targhe ripetitrici (rimorchi/agricole): AB R 000 AB (2 lettere + R + alfanumerici)
  /^[A-Z]{2}R[A-Z0-9]{4,6}$/,
  // Macchine agricole semoventi (2 lettere + 3 cifre + 1 lettera): AB123C
  /^[A-Z]{2}\d{3}[A-Z]$/,
  // Macchine agricole (2 lettere + 5 cifre, con prefisso/serie): AB12345 (coperto sopra)
  // Macchine operatrici semoventi (2 lettere + 1 lettera + 3 cifre): ABC — coperto da 3L+3N
  // Targhe prova (regolamento): AAP1234 (auto/rimorchi), AAP123 (moto), + MA/MO
  /^[A-Z]{2}P\d{3,4}$/,
  /^[A-Z]{2}P\d{3}(MA|MO)$/,
  // Targhe prova/speciali con prefisso Z (ZA..ZZ + cifre)
  /^Z[ABCDEFHIJKLMPRSTUVXYZ]\d{3,5}$/,
  // Corpo Diplomatico / Consolare (CD/CC + cifre, con eventuale sigla stato numerica)
  /^(CD|CC)\d{2,5}$/,
  /^\d{2,3}(CD|CC)\d{2,4}$/,
  // Escursionisti Esteri (EE): EE123AB (auto), EE123A (moto), con eventuale sigla stato
  /^EE\d{3}[A-Z]{1,2}$/,
  /^[A-Z]{1,3}EE\d{3}[A-Z]{1,2}$/,
  // Altre speciali con prefisso (EE, EP, CC, CD, X) + cifre
  /^(EE|EP|CC|CD|X)\d{3,6}$/,
  // Veicoli storici / formati con eventuale suffisso anno (es. targa storica + anno)
  /^[A-Z]{2}\d{3}[A-Z]{2}\d{2,4}$/,
];

export function isValidTarga(t) {
  const raw = String(t || "").trim();
  const s = normTarga(t);
  if (!raw) return true;   // vuoto = nessun errore (non bloccante nei form)
  if (!s) return false;    // solo simboli/caratteri non alfanumerici = errato
  if (s.length < 4 || s.length > 10) return false;
  return TARGA_PATTERNS.some((r) => r.test(s));
}
